module.exports = __webpack_public_path__ + "static/img/require01.53edb4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/head/require01.jpg
// module id = Xthl
// module chunks = 8